module.exports = __webpack_public_path__ + "img/home_icon_wsignup@2x.2f2d0628.png";